export const colors = {
  generosityBackgroundDefault: "#FFDC2E",
  generosityBackgroundSubtle: "#FFF6BD",
  generosityBackgroundStrong: "#EAC300",
  generosityBackgroundStaticDefault: "#FFDC2E",
  generosityBackgroundStaticSubtle: "#FFF6BD",
  generosityBackgroundStaticStrong: "#EAC300",
  generosityBackgroundCasinoDefault: "#C18FFE",
  generosityBackgroundCasinoSubtle: "#F6F1FE",
  generosityBackgroundCasinoStrong: "#A530F3",
  generosityBackgroundCasinoStatic: "#C18FFE",
  generosityBackgroundRacingDefault: "#7FD9A1",
  generosityBackgroundRacingSubtle: "#BCEBCE",
  generosityBackgroundRacingStrong: "#31C268",
  generosityBackgroundRacingStatic: "#7FD9A1",
  generosityBorderDefault: "#EAC300",
  generosityBorderSubtle: "#FFDC2E",
  generosityBorderStaticDefault: "#EAC300",
  generosityBorderStaticSubtle: "#FFDC2E",
  generosityBorderCasinoDefault: "#C18FFE",
  generosityBorderCasinoSubtle: "#D4B6FE",
  generosityBorderCasinoStatic: "#C18FFE",
  generosityBorderRacingDefault: "#7FD9A1",
  generosityBorderRacingSubtle: "#BCEBCE",
  generosityBorderRacingStatic: "#7FD9A1",
  generosityGradientDefault: "linear-gradient(45deg, #FFDC2E 50%, #FFF6BD 88%)",
  generosityGradientStart: "#FFDC2E",
  generosityGradientEnd: "#FFF6BD",
  generosityGradientCasinoDefault: "linear-gradient(45deg, #C18FFE 50%, #F6F1FE 88%)",
  generosityGradientCasinoStart: "#C18FFE",
  generosityGradientCasinoEnd: "#F6F1FE",
  generosityGradientRacingDefault: "linear-gradient(45deg, #7FD9A1 50%, #BCEBCE 88%)",
  generosityGradientRacingStart: "#7FD9A1",
  generosityGradientRacingEnd: "#BCEBCE",
};